import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SeguridadService} from '@servicios/Seguridad.service';
import { ConsultaAcuerdoComponent } from './consultaacuerdo/consultaacuerdo.component';
import { AcuerdoPendienteComponent } from './acuerdopendiente/acuerdopendiente.component';


const routes: Routes = [
    {path: '', redirectTo: 'colaborador', pathMatch: 'full'},
    {path: 'consultaacuerdos', component: ConsultaAcuerdoComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'acuerdospendientes', component: AcuerdoPendienteComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AcuerdoRoutingModule {}
